var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_7930","data-name":"Path 7930","d":"M58.692,181.94h109.74A4.918,4.918,0,0,1,173.4,188l-17.3,63.3c-1.373,5.041-8.517,5.956-11.272,1.453l-25.643-41.983L57.089,191.4A4.824,4.824,0,0,1,58.692,181.94Z","transform":"translate(-53.563 -181.94)"}));
}

Arrow.defaultProps = {"viewBox":"0 0 120 73.726"};

module.exports = Arrow;

Arrow.default = Arrow;
